export default __webpack_public_path__ + "static/partner3-c6a11595e1dc67da3ebe6445f0666f04.png";